import styled from 'styled-components';
import { clsPrefix } from '../../avatar.styled';
import { AVATAR_MARK_SIZE_MAP } from './avatar-mark.utils';

export const AvatarMarkSC = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 1;
  border-width: 1px;
  border-color: ${({ theme }) => theme.color.surface.secondary};
  background-color: ${({ theme }) => theme.color.surface.baseline};

  &.on-dark {
    border-color: ${({ theme }) => theme.color.surface.secondaryDark};
  }

  ${`${clsPrefix} Xlarge`}& {
    width: ${AVATAR_MARK_SIZE_MAP['Xlarge']}px;
    height: ${AVATAR_MARK_SIZE_MAP['Xlarge']}px;
  }

  ${`${clsPrefix} large`}& {
    width: ${AVATAR_MARK_SIZE_MAP['large']}px;
    height: ${AVATAR_MARK_SIZE_MAP['large']}px;
  }

  ${`${clsPrefix} medium`}& {
    width: ${AVATAR_MARK_SIZE_MAP['medium']}px;
    height: ${AVATAR_MARK_SIZE_MAP['medium']}px;
  }

  ${`${clsPrefix} small`}& {
    width: ${AVATAR_MARK_SIZE_MAP['small']}px;
    height: ${AVATAR_MARK_SIZE_MAP['small']}px;
  }

  ${`${clsPrefix} Xsmall`}& {
    width: ${AVATAR_MARK_SIZE_MAP['Xsmall']}px;
    height: ${AVATAR_MARK_SIZE_MAP['Xsmall']}px;
  }
`;
